import { render, staticRenderFns } from "./MyBusiness.vue?vue&type=template&id=98856232&"
import script from "./MyBusiness.vue?vue&type=script&lang=js&"
export * from "./MyBusiness.vue?vue&type=script&lang=js&"
import style0 from "./MyBusiness.vue?vue&type=style&index=0&lang=scss&rel=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports